webpackJsonp([212839066777427],{

/***/ 133:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"src-components-Card----Card-module---Card---VK6eT"};

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardModule = __webpack_require__(133);
	
	var _CardModule2 = _interopRequireDefault(_CardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(_ref) {
	  var padding = _ref.padding,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: { padding: typeof padding ? padding : '10px' },
	      className: _CardModule2.default.Card
	    },
	    children
	  );
	};
	
	Card.propTypes = {
	  children: _propTypes2.default.any.isRequired,
	  padding: _propTypes2.default.number
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PostItem":"src-components-Posts-PostItem----PostItem-module---PostItem---1_D9A","Feature":"src-components-Posts-PostItem----PostItem-module---Feature---313OV","Content":"src-components-Posts-PostItem----PostItem-module---Content---2iM57","Title":"src-components-Posts-PostItem----PostItem-module---Title---OE_Fj","Date":"src-components-Posts-PostItem----PostItem-module---Date---1Dorj"};

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PostItemModule = __webpack_require__(135);
	
	var _PostItemModule2 = _interopRequireDefault(_PostItemModule);
	
	var _Card = __webpack_require__(98);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * PostItem can be nested only inside PostLoop
	 */
	var PostItem = function PostItem(_ref) {
	  var post = _ref.post;
	  var frontmatter = post.frontmatter;
	  var fields = post.fields;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _PostItemModule2.default.PostItem },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' + post.fields.slug },
	      _react2.default.createElement(
	        _Card2.default,
	        { padding: 0 },
	        _react2.default.createElement('div', {
	          className: _PostItemModule2.default.Feature,
	          style: {
	            backgroundImage: frontmatter.feature ? 'url(' + post.frontmatter.feature + ')' : 'url(https://source.unsplash.com/daily?coding)'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _PostItemModule2.default.Content },
	          _react2.default.createElement(
	            'h3',
	            { className: _PostItemModule2.default.Title },
	            frontmatter.title
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _PostItemModule2.default.Date },
	            frontmatter.date
	          )
	        )
	      )
	    )
	  );
	};
	
	PostItem.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	exports.default = PostItem;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PostLoop":"src-components-Posts-PostLoop----PostLoop-module---PostLoop---192AW","SearchBar":"src-components-Posts-PostLoop----PostLoop-module---SearchBar---3k6No","Filters":"src-components-Posts-PostLoop----PostLoop-module---Filters---3ljlw"};

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PostItem = __webpack_require__(102);
	
	var _PostItem2 = _interopRequireDefault(_PostItem);
	
	var _PostLoopModule = __webpack_require__(136);
	
	var _PostLoopModule2 = _interopRequireDefault(_PostLoopModule);
	
	var _TextInput = __webpack_require__(100);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(97);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      searchString: '',
	      posts: props.data.posts.edges
	    };
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.reversePosts = _this.reversePosts.bind(_this);
	    return _this;
	  }
	
	  _class.prototype.handleSearch = function handleSearch(event) {
	    var val = event.target.value;
	    this.setState(function () {
	      return { searchString: val };
	    });
	  };
	
	  _class.prototype.reversePosts = function reversePosts() {
	    this.setState(function (prevState) {
	      return { posts: prevState.posts.reverse() };
	    });
	  };
	
	  _class.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _PostLoopModule2.default.PostLoop },
	      this.props.search && _react2.default.createElement(
	        'div',
	        { className: _PostLoopModule2.default.SearchBar },
	        _react2.default.createElement(_TextInput2.default, {
	          autoFocus: true,
	          placeholder: 'Search... e.g `react`, `jest`',
	          onChange: this.handleSearch
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _PostLoopModule2.default.Filters },
	          _react2.default.createElement(_Button2.default, { title: 'Sort', onClick: this.reversePosts })
	        )
	      ),
	      this.state.posts.map(function (post) {
	        return post.node.frontmatter.title.toUpperCase().match(_this2.state.searchString.toUpperCase()) && _react2.default.createElement(_PostItem2.default, { key: post.node.fields.slug, post: post.node });
	      })
	    );
	  };
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(24);
	
	var _PostLoop = __webpack_require__(103);
	
	var _PostLoop2 = _interopRequireDefault(_PostLoop);
	
	var _Hero = __webpack_require__(23);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hero2.default, {
	      title: 'Blog',
	      hasHeader: true,
	      subtitle: 'Notes about the web, development, and design.'
	    }),
	    _react2.default.createElement(
	      _Layout.Container,
	      { padding: true },
	      _react2.default.createElement(_PostLoop2.default, { data: data, search: true })
	    )
	  );
	};
	
	exports.default = SecondPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-f1363264cb2d68d1e0ac.js